import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';

// Amplifyの設定
Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: 'ap-northeast-1_l5yxWYv1a', // CognitoユーザープールIDを更新
      userPoolClientId: '2u5312np8mbuqce6q2721nprdk',   // CognitoのアプリクライアントID
      loginWith: {
        oauth: {
          domain: 'auth.quicksight-viewer.imlab.cloud', // カスタムドメインに更新
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: ['https://quicksight-viewer.imlab.cloud/'],
          redirectSignOut: ['https://quicksight-viewer.imlab.cloud/'],
          responseType: 'code'
        }
      }
    }
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
